import { useState } from 'react';
import { currentUser, logout, updatePassword } from '../identity.js';

/** Shown after a recovery or invite link, where the account has no usable password. */
export default function SetPassword({ heading, blurb, onDone }) {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const user = currentUser();

  async function submit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await updatePassword(password);
      onDone();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="gate">
      <form className="gate-card" onSubmit={submit}>
        <div className="gate-wordmark">Longhand</div>
        <p className="gate-sub">{blurb}</p>
        {user?.email && <p className="gate-note">Signed in as {user.email}.</p>}

        <label className="gate-field">
          <span>{heading}</span>
          <input
            type="password" autoComplete="new-password" required minLength={8} autoFocus
            value={password} onChange={e => setPassword(e.target.value)}
          />
        </label>

        {error && <p className="gate-note is-bad">{error}</p>}

        <button className="gate-submit" type="submit" disabled={busy}>
          {busy ? 'Saving…' : 'Save and continue'}
        </button>
        <div className="gate-alt">
          <button type="button" onClick={logout}>Cancel</button>
        </div>
      </form>
    </div>
  );
}
